import { render, staticRenderFns } from "./TPCN.vue?vue&type=template&id=5e0aacd2&scoped=true&"
import script from "./TPCN.vue?vue&type=script&lang=js&"
export * from "./TPCN.vue?vue&type=script&lang=js&"
import style0 from "./TPCN.vue?vue&type=style&index=0&id=5e0aacd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0aacd2",
  null
  
)

export default component.exports